import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { Field, useFormState } from 'react-final-form';
import { cityQuery } from '../../../queries';
import Loader from '../../Loader';
import { setError } from '../../../actions';
import NewSearchPopup from '../NewSearchPopup';
import NewSearchCity from './NewSearchCity';
import { useCityHasLocations } from '../../../utils/helpers/common';
import ErrorField from '../../ItemCreationForm/AddNewItemForm/components/ErrorField';
import { FORM_VALUES } from '../../../utils/helpers/constants';

const NewSearchCities = ({
  listType,
  setCitiesLoading,
  citiesPopupIsOpen,
  toggleHandlerCities
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { values } = useFormState();
  const isCreate = listType === 'create';
  const [isError, setIsError] = useState(false);
  const currentCity = useSelector(state => state.searchForm.currentCity);
  const cityId = {
    id: values.city_id || currentCity
  };
  const { data, loading, error } = useQuery(cityQuery(cityId), {
    variables: cityId
  });
  const title = `${t('search.city_search.title')}${isCreate ? ' *' : ''}`;
  useCityHasLocations(values.city_id);

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  const cityText = isCreate ? '' : t('search.city_search.any');
  const cityName = data && data.city != null ? data.city.name : cityText;

  useEffect(() => {
    setCitiesLoading(loading);
  }, [loading]);

  return (
    <>
      <Field name="city_id" component="input" type="hidden" />
      <div
        tabIndex={0}
        role="button"
        data-cy="chosen-city"
        className="city__container"
        onClick={toggleHandlerCities}
        onKeyPress={toggleHandlerCities}
        data-stat="new-search-form-city"
      >
        <div className="city">
          <div className="city__label">{title}</div>
          <Loader loading={loading} optionalClass="city__loader">
            <div className="city__name" data-cy="city-name">
              {cityName}
            </div>
          </Loader>
        </div>
        <NewSearchPopup
          popupTitle={title}
          listType={listType}
          modalId="select-city"
          isOpen={citiesPopupIsOpen}
          data-cy="modal-select-city"
          closeHandler={toggleHandlerCities}
          additionalClass="new-search-popup--cities"
          inputPlaceholder={t('new_search.search_city')}
        >
          {(searchString, isFocused, cancelHandler) => (
            <NewSearchCity
              closePopupHandler={toggleHandlerCities}
              {...{ isFocused, searchString, cancelHandler, listType }}
            />
          )}
        </NewSearchPopup>
      </div>
      {isCreate && (
        <ErrorField
          setError={setIsError}
          margin={isError ? 15 : 0}
          field={FORM_VALUES.cityId}
          cypress="city-id-field-error"
        />
      )}
    </>
  );
};

NewSearchCities.propTypes = {
  listType: PropTypes.string,
  setCitiesLoading: PropTypes.func.isRequired,
  citiesPopupIsOpen: PropTypes.bool.isRequired,
  toggleHandlerCities: PropTypes.func.isRequired
};

NewSearchCities.defaultTypes = {
  listType: 'search'
};

export default NewSearchCities;
